// React entry point for the v0.2 WebUI MVP.

import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found in index.html");
}
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
